import RepositoryFactory from "../../admin/apis/index";
const tags = RepositoryFactory.tags;

export default {
  addTags({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await tags.addTags(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  editTags({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await tags.editTags(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getTags({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await tags.getTags();

        commit("SET_TAGS", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getAllTags({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await tags.getAllTags(payload);

        commit("SET_AllTAGS", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
